import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SponsorTab.module.scss';
import { SponsorItem } from '../../data/SponsorData';

interface SponsorTabProps {
  sponsors: SponsorItem[];
}

const SponsorTab: React.FC<SponsorTabProps> = ({ sponsors }) => {
  const { t } = useTranslation();

  return (
    <div className={styles['sponsor-tab-container']}>
      <div className={styles['scrolling-content']}>
        {sponsors.map((sponsor, index) => (
          <React.Fragment key={index}>
            <div className={styles['content-item']}>
              <span className={styles['icons']}>
                <img src={sponsor.icon} alt={t(sponsor.label)} />
              </span>
              <span className={styles['label']}>{t(sponsor.label)}</span>
              <span className={styles['value']}>{sponsor.value}</span>
            </div>
            {index < sponsors.length - 1 && <div className={styles['divider']}></div>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default SponsorTab;
